// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* Background is handled by the MUI theme */
  min-height: 100vh;
  overflow-x: hidden;
  box-sizing: border-box;
}

/* Ensure all elements use border-box */
*,
*::before,
*::after {
  box-sizing: border-box;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

/* Responsive spacing utilities */
.responsive-container {
  padding-left: 8px;
  padding-right: 8px;
}

@media (min-width: 600px) {
  .responsive-container {
    padding-left: 16px;
    padding-right: 16px;
  }
}

@media (min-width: 960px) {
  .responsive-container {
    padding-left: 24px;
    padding-right: 24px;
  }
}

/* Fix MUI Grid spacing issues */
.MuiGrid-root {
  max-width: 100%;
}

.MuiGrid-item {
  max-width: 100%;
}

/* Responsive cards */
.responsive-card {
  margin: 8px 4px;
}

@media (min-width: 600px) {
  .responsive-card {
    margin: 12px 8px;
  }
}

@media (min-width: 960px) {
  .responsive-card {
    margin: 16px 12px;
  }
}

/* Better responsive buttons */
.responsive-button-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

@media (min-width: 600px) {
  .responsive-button-group {
    flex-direction: row;
    gap: 12px;
  }
}

/* Fix overflow issues */
.content-wrapper {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

/* Ensure proper spacing in lists */
.MuiList-root {
  padding-top: 8px;
  padding-bottom: 8px;
}

/* Better mobile typography */
@media (max-width: 600px) {
  .MuiTypography-h4 {
    font-size: 1.5rem !important;
  }

  .MuiTypography-h5 {
    font-size: 1.25rem !important;
  }

  .MuiTypography-h6 {
    font-size: 1.1rem !important;
  }
}

/* Fix card layout issues */
.dashboard-card {
  position: relative;
  overflow: visible;
}

.dashboard-card .card-content {
  position: relative;
  padding-bottom: 60px; /* Space for chips */
}

.dashboard-card .card-chips {
  position: absolute;
  bottom: 6px;
  left: 16px;
  right: 16px;
  z-index: 2;
}

.dashboard-card .card-actions {
  position: relative;
  z-index: 1;
}

/* Ensure proper spacing in card elements */
.MuiCardContent-root {
  position: relative !important;
}

.MuiCardActions-root {
  margin-top: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,uCAAuC;AACvC;;;EAGE,sBAAsB;AACxB;;AAEA;EACE;aACW;AACb;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,gCAAgC;AAChC;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE;IACE,mBAAmB;IACnB,SAAS;EACX;AACF;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB,EAAE,oBAAoB;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,2CAA2C;AAC3C;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* Background is handled by the MUI theme */\n  min-height: 100vh;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n\n/* Ensure all elements use border-box */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n/* Responsive spacing utilities */\n.responsive-container {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n@media (min-width: 600px) {\n  .responsive-container {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n}\n\n@media (min-width: 960px) {\n  .responsive-container {\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n}\n\n/* Fix MUI Grid spacing issues */\n.MuiGrid-root {\n  max-width: 100%;\n}\n\n.MuiGrid-item {\n  max-width: 100%;\n}\n\n/* Responsive cards */\n.responsive-card {\n  margin: 8px 4px;\n}\n\n@media (min-width: 600px) {\n  .responsive-card {\n    margin: 12px 8px;\n  }\n}\n\n@media (min-width: 960px) {\n  .responsive-card {\n    margin: 16px 12px;\n  }\n}\n\n/* Better responsive buttons */\n.responsive-button-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n@media (min-width: 600px) {\n  .responsive-button-group {\n    flex-direction: row;\n    gap: 12px;\n  }\n}\n\n/* Fix overflow issues */\n.content-wrapper {\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\n/* Ensure proper spacing in lists */\n.MuiList-root {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n/* Better mobile typography */\n@media (max-width: 600px) {\n  .MuiTypography-h4 {\n    font-size: 1.5rem !important;\n  }\n\n  .MuiTypography-h5 {\n    font-size: 1.25rem !important;\n  }\n\n  .MuiTypography-h6 {\n    font-size: 1.1rem !important;\n  }\n}\n\n/* Fix card layout issues */\n.dashboard-card {\n  position: relative;\n  overflow: visible;\n}\n\n.dashboard-card .card-content {\n  position: relative;\n  padding-bottom: 60px; /* Space for chips */\n}\n\n.dashboard-card .card-chips {\n  position: absolute;\n  bottom: 6px;\n  left: 16px;\n  right: 16px;\n  z-index: 2;\n}\n\n.dashboard-card .card-actions {\n  position: relative;\n  z-index: 1;\n}\n\n/* Ensure proper spacing in card elements */\n.MuiCardContent-root {\n  position: relative !important;\n}\n\n.MuiCardActions-root {\n  margin-top: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
